module.exports = __webpack_public_path__ + "img/1.d39683e2.jpg";